export { Attachments } from "./attachments";
export { EmailComposer } from "./email-composer";
export type { EmailComposerProps, EmailComposerRef } from "./email-composer";
export type { EmailStyleSettings } from "./context";
export { useEmailAttachments } from "./hooks/use-email-attachments";
export { useContentVersion } from "./hooks/use-content-version";
export type { EmailAttachmentFile } from "./hooks/use-email-attachments";
export { useEmailRecipients } from "./hooks/use-email-recipients";
export type { UseEmailRecipientsReturn } from "./hooks/use-email-recipients";
export { EmailRecipientField, RecipientField } from "./recipient-field";
export type { RecipientSuggestion } from "./hooks/use-recipient-suggestions";
export { EMAIL_RE } from "./hooks/use-email-recipients";
